import { post, get, del, put } from './requests'

export const searchItems = key => payload => {
  return post(
    ['api', 'search', 'contains'],
    {
      removeTrailingSlash: true,
      headers: { Authorization: `Bearer ${key}` },
    },
    payload
  )
}



// WEBPACK FOOTER //
// ./src/services/search.js